import { render, staticRenderFns } from "./ButtonSpacer.vue?vue&type=template&id=926a13a4&scoped=true&"
import script from "./ButtonSpacer.vue?vue&type=script&lang=ts&"
export * from "./ButtonSpacer.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonSpacer.vue?vue&type=style&index=0&id=926a13a4&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926a13a4",
  null
  
)

export default component.exports